export default __webpack_public_path__ + "static/smartWorkflowImg4-ded5d1ec5cff0282fe70f2a2aac5d070.png";